import Alpine from 'alpinejs';
Alpine.data('shortcutCreationForm', () => ({
    loading: true,
    target: null,
    parentNodePath: null,
    uriPathSegment: null,
    uriPathSegmentIsValid: true,
    suggestedUriPathSegment: '',

    init () {
        this.$nextTick(async () => {
            if (this.uriPathSegment) {
                this.loading = true;
                const foreignUriPathSegment = await this.checkUriPathSegment(this.uriPathSegment)
                if (this.uriPathSegment === foreignUriPathSegment) {
                    this.uriPathSegmentIsValid = true;
                } else {
                    this.uriPathSegmentIsValid = false;
                    this.suggestedUriPathSegment = foreignUriPathSegment;
                }
            }

            this.loading = false;
        })
    },

    uriPathSegmentInput: {
        async ['@input.debounce'](e) {
            if (!e.target.value) {
                this.uriPathSegmentIsValid = true;
                return
            }

            this.loading = true;
            const foreignUriPathSegment = await this.checkUriPathSegment(e.target.value)
            if (this.uriPathSegment === foreignUriPathSegment) {
                this.uriPathSegmentIsValid = true;
            } else {
                this.uriPathSegmentIsValid = false;
                this.suggestedUriPathSegment = foreignUriPathSegment;
            }
            this.loading = false;
        }
    },

    async checkUriPathSegment (text) {
        const response = await fetch(`/codeq/shortcuts/validateuripathsegment.json?parentNode=${encodeURIComponent(this.parentNodePath)}&text=${encodeURIComponent(text)}`)
        const jsonData = await response.json();
        return jsonData.uriPathSegment;
    },

    applySuggestedUriPathSegment () {
        this.uriPathSegment = this.suggestedUriPathSegment
        this.uriPathSegmentIsValid = true
    },

    get canSubmit () {
        const uriRegex = /^(https:\/\/)[-a-zA-Z0-9@:%._\\+~#?&//=]{2,256}\.[a-z]{2,6}\/*([-a-zA-Z0-9@:%._\\+~#?&//=]*)$/g
        return !this.loading && this.uriPathSegmentIsValid && uriRegex.test(this.target)
    }
}));
